import { SectionView } from "../components/templates/SectionView.tsx";
import { ProjectsTray } from "../components/organisms/ProjectsTray.tsx";

export function ProjectsPage() {
  return (
    <SectionView
      ariaLabel="Projects"
      title="Projects"
      sub="Things I've shipped — open source and otherwise. Some for myself first, some that turned out useful for others too."
    >
      <ProjectsTray />
    </SectionView>
  );
}
